import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Error from '@/components/Error';
import Terms from '@/components/Terms';
import Home from '@/components/home/Home';
import Winners from '@/components/Winners';
import Store from '@/components/home/Store';
import Index from '@/components/visitor/Index';
import Game from '@/components/home/game/Game';
import Login from '@/components/visitor/Login';
import HowItWorks from '@/components/HowItWorks';
import Prizes from '@/components/visitor/Prizes';
import Visitor from '@/components/visitor/Visitor';
import Profile from '@/components/home/profile/Profile';
import SignUp3 from '@/components/visitor/signup/SignUp3';
import SignUp2 from '@/components/visitor/signup/SignUp2';
import TwoStepRegistration2 from '@/components/visitor/signup/TwoStepRegistration2';
import TwoStepRegistration1 from '@/components/visitor/signup/TwoStepRegistration1';
import Achievements from '@/components/home/Achievements';
import Notifications from '@/components/home/Notifications';
import StressTest from '@/components/stressTests/StressTest';
import ResumingGame from '@/components/home/game/ResumingGame';
import StressTest2 from '@/components/stressTests/StressTest2';
import StressTest3 from '@/components/stressTests/StressTest3';
import StressTest4 from '@/components/stressTests/StressTest4';
import ProfileEdit from '@/components/home/profile/ProfileEdit';
import OpponentFound from '@/components/home/game/OpponentFound';
import HomeDefaultContent from '@/components/home/DefaultContent';
import HowItWorksLoggedIn from '@/components/home/HowItWorksLoggedIn';
import SearchingOpponent from '@/components/home/game/SearchingOpponent';
import TestFullGameScenario from '@/components/stressTests/TestFullGameScenario';
import ForgotPassword1 from '@/components/visitor/forgotPassword/ForgotPassword1';
import ForgotPassword2 from '@/components/visitor/forgotPassword/ForgotPassword2';
import ForgotPassword3 from '@/components/visitor/forgotPassword/ForgotPassword3';
import TwoStepForgotPassword1 from '@/components/visitor/forgotPassword/TwoStepForgotPassword1';
import TwoStepForgotPassword2 from '@/components/visitor/forgotPassword/TwoStepForgotPassword2';
import ProfileDefaultContent from '@/components/home/profile/DefaultContentProfile';
import SignUp1SingleCountry from '@/components/visitor/signup/SignUp1SingleCountry';
import GetStartedFreePlay from '@/components/visitor/freeTrial/GetStartedFreePlay';
import FreePlayIndex from '@/components/visitor/freeTrial/Index';
import SearchingOpponentFreePlay from '@/components/visitor/freeTrial/SearchingOpponentFreePlay';
import GameFreePlayAddOn from '@/components/visitor/freeTrial/GameFreePlayAddOn';
import Version from '@/components/Version';
import Credits from '@/components/Credits';
import Consent from '@/components/Consent';
import AddOnGame from '@/components/home/game/addongame/AddOnGame';
import ExchangeStars from '@/components/home/ExchangeStars';
import PostGameAddOn from '@/components/home/game/addongame/PostGameAddOn';

Vue.use(Router);

// this navigation guard is used when the user is in any page under the home path
// such as ...?#/home/store and tries to enter a game component's url explicitly such as ...?#/game
const gameNavigationGuard = (to, from, next) => {
  if (from.path.includes('home')) {
    next(false);
  } else {
    next();
  }
};

// EXC-1705
const prizesNavigationGuard = (to, from, next) => {
  if (store.state.common.hidePrizePage) {
    next({ path: '/' });
  } else {
    next();
  }
};

const freeTrialGameAccessGuard = (to, from, next) => {
  if (from.path.includes('trial')) next();
  else next('/');
};

const twoStepRegistration = (to, from, next) => {
  const flowName = store.getters['common/getSimpleRegistration'];
  if (store.getters['common/getTwoStepsRegistration']) {
    // eslint-disable-next-line
    if (to.path === '/register1') {
      next({ path: '/twostepregister1' });
    } else if (to.path === '/register2') {
      next({ path: '/twostepregister2' });
    } else {
      // eslint-disable-next-line
      if (!store.getters['common/getAvailableFlowsInfo'][flowName].blockedRoutes.includes(to.path)) next();
      else next({ path: '/' });
    }
  } else {
    // eslint-disable-next-line
    if (!store.getters['common/getAvailableFlowsInfo'][flowName].blockedRoutes.includes(to.path)
      && to.path !== '/twostepregister1' && to.path !== '/twostepregister2') {
      next();
    } else next({ path: '/' });
  }
};

const twoStepForgotPassword = (to, from, next) => {
  const flowName = store.getters['common/getSimpleRegistration'];
  // eslint-disable-next-line
  const forbiddenRoutes = store.getters['common/getAvailableFlowsInfo'][flowName].blockedRoutes;
  let finalDestination;
  if (store.getters['common/getTwoStepsRegistration']) {
    switch (to.path) {
    case '/forgotPassword1': finalDestination = '/twostepforgotPassword1';
      break;
    case '/forgotPassword2': finalDestination = '/twostepforgotPassword2';
      break;
    case '/home/profile/forgotPassword1': finalDestination = '/home/profile/twostepforgotPassword1';
      break;
    case '/home/profile/forgotPassword2': finalDestination = '/home/profile/twostepforgotPassword2';
      break;
    default: break;
    }
    if (finalDestination && !forbiddenRoutes.includes(finalDestination)) {
      next({ path: finalDestination });
    } else if (!forbiddenRoutes.includes(to.path)) {
      next();
    } else {
      next({ path: '/' });
    }
  } else {
    // eslint-disable-next-line
    if (!store.getters['common/getAvailableFlowsInfo'][flowName].blockedRoutes.includes(to.path)) next();
    else next({ path: '/' });
  }
};

const isExchangeStarsImplActive = (to, from, next) => {
  if (store.getters['common/hideExchangeStarsImpl']) next({ path: '/' });
  else next();
};

const twoStepForgotPassword2 = (to, from, next) => {
  const flowName = store.getters['common/getSimpleRegistration'];
  if (store.getters['common/getTwoStepsRegistration']) {
    if (!store.getters['common/getAvailableFlowsInfo'][flowName].blockedRoutes.includes(to.path)) next();
    else next({ path: '/' });
  } else {
    next({ path: '/' });
  }
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Visitor,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          component: Index,
          name: 'index',
        },
        {
          path: 'prizes',
          component: Prizes,
          name: 'prizes',
          beforeEnter: prizesNavigationGuard,
        },
        {
          path: 'winners',
          component: Winners,
          name: 'winners',
        },
        {
          path: 'credits',
          component: Credits,
          name: 'credits',
        },
        {
          path: 'terms',
          component: Terms,
          name: 'terms',
        },
        {
          path: 'howItWorks',
          component: HowItWorks,
          name: 'howItWorks',
        },
        {
          path: 'register1',
          component: SignUp1SingleCountry,
          name: 'register1',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'register2',
          component: SignUp2,
          name: 'register2',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'register3',
          component: SignUp3,
          name: 'register3',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'twostepregister1',
          component: TwoStepRegistration1,
          name: 'twoStepRegister1',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'twostepregister2',
          name: 'twoStepRegister2',
          component: TwoStepRegistration2,
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'login',
          name: 'login',
          component: Login,
        },
        {
          path: 'forgotPassword1',
          component: ForgotPassword1,
          name: 'forgotPassword1',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'forgotPassword2',
          component: ForgotPassword2,
          name: 'forgotPassword2',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'forgotPassword3',
          component: ForgotPassword3,
          name: 'forgotPassword3',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'twostepforgotPassword1',
          name: 'twoStepForgotPassword1',
          component: TwoStepForgotPassword1,
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'twostepforgotPassword2',
          name: 'twoStepForgotPassword2',
          component: TwoStepForgotPassword2,
          beforeEnter: twoStepForgotPassword2,
        },
      ],
    },
    {
      // path: '/home/:id',
      path: '/home',
      component: Home,
      // a meta field
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          component: HomeDefaultContent,
          name: 'homeDefault',
        },
        {
          path: 'exchangeStars',
          component: ExchangeStars,
          name: 'exchangeStars',
          beforeEnter: isExchangeStarsImplActive,
        },
        {
          path: 'notifications',
          component: Notifications,
          name: 'notifications',
        },
        {
          path: 'profile',
          component: Profile,
          children: [
            {
              path: '',
              component: ProfileDefaultContent,
              name: 'profileDefault',
            },
            {
              path: 'edit',
              component: ProfileEdit,
              name: 'edit',
            },
          ],
        },
        {
          path: 'forgotPassword1',
          component: ForgotPassword1,
          name: 'profileForgotPassword1',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'forgotPassword2',
          component: ForgotPassword2,
          name: 'profileForgotPassword2',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'forgotPassword3',
          component: ForgotPassword3,
          name: 'profileForgotPassword3',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'twostepforgotPassword1',
          name: 'profileTwoStepForgotPassword1',
          component: TwoStepForgotPassword1,
        },
        {
          path: 'twostepforgotPassword2',
          name: 'profileTwoStepForgotPassword2',
          component: TwoStepForgotPassword2,
        },
        {
          path: 'store',
          component: Store,
          name: 'store',
        },
        {
          path: 'winners',
          component: Winners,
          name: 'winnersHome',
          meta: { requiresAuth: true },
        },
        {
          path: 'achievements',
          name: 'achievements',
          component: Achievements,
        },
        {
          path: 'howitworksLoggedIn',
          name: 'howItWorksLoggedIn',
          component: HowItWorksLoggedIn,
        },
        {
          path: 'terms',
          component: Terms,
          name: 'termsHome',
          meta: { requiresAuth: true },
        },
      ],
    },
    {
      path: '/trial',
      component: FreePlayIndex,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          component: GetStartedFreePlay,
          name: 'getStartedFreePlay',
        },
        {
          path: 'searchingOpponent',
          component: SearchingOpponentFreePlay,
          name: 'searchingOpponentFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'game',
          component: GameFreePlayAddOn,
          name: 'gameFreePlayAddOn',
          beforeEnter: freeTrialGameAccessGuard,
        },
      ],
    },
    {
      path: '/postGameAddOn',
      component: PostGameAddOn,
      name: 'postGameAddOn',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/searchingOpponent',
      component: SearchingOpponent,
      name: 'searchingOpponent',
      meta: { requiresAuth: true },
    },
    {
      path: '/opponentFound',
      component: OpponentFound,
      name: 'opponentFound',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/addOnGame',
      component: AddOnGame,
      name: 'addOnGame',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/game',
      component: Game,
      name: 'game',
      meta: { requiresAuth: true },
      params: true,
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/resumingGame',
      component: ResumingGame,
      name: 'resumingGame',
      meta: { requiresAuth: true },
    },
    {
      path: '/stressTest',
      component: StressTest,
      name: 'StressTest',
      meta: { requiresAuth: false },
    },
    {
      path: '/stressTest2',
      component: StressTest2,
      name: 'StressTest2',
      meta: { requiresAuth: false },
    },
    {
      path: '/stressTest3',
      component: StressTest3,
      name: 'StressTest3',
      meta: { requiresAuth: false },
    },
    {
      path: '/stressTest4',
      component: StressTest4,
      name: 'StressTest4',
      meta: { requiresAuth: false },
    },
    {
      path: '/testGameFlow/:msisdn',
      component: TestFullGameScenario,
      name: 'TestFullGameScenario',
      meta: { requiresAuth: false },
    },
    {
      path: '/version',
      component: Version,
      name: 'Version',
      meta: { requiresAuth: false },
    },
    {
      path: '/consent',
      component: Consent,
      name: 'Consent',
      meta: { requiresAuth: false },
    },
    {
      path: '/error',
      component: Error,
      name: 'error',
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js